import { Suspense, type SuspenseProps } from 'react'

import useHydrationContext from '@/hooks/useHydrationContext'

/**
 * Suspense helper wrapper - using React.Suspense with SSR might result in Suspense-hydration error https://github.com/facebook/react/blob/main/scripts/error-codes/codes.json#L409
 */
export const SuspenseWrapper = ({ children, fallback }: SuspenseProps) => {
  const hydrated = useHydrationContext()

  return <Suspense fallback={fallback}>{hydrated ? children : null}</Suspense>
}
